import React from 'react';
import SingleLink from '../single-link';
import LinkWithPage from '../link-with-page';
import INavigationLink from '../../../../../../interfaces/navigation-link';
import IMobileMenu from '../../../../../../interfaces/mobile-menu';

interface IProps extends IMobileMenu {
	pages: INavigationLink[];
	trackMenu?: (text: string) => void;
	pageDepth?: number;
	label?: string;
}

function DrawerMenuLinks({
	pages,
	trackMenu,
	hideIcons = false,
	pageDepth = 0,
	pageClick,
	label = 'hamburger_icon',
}: IProps): JSX.Element {
	return (
		<div data-nested-menu-label={label}>
			{pages.map(page => {
				if (!page) {
					return null;
				}

				const showAccordion = page?.subCategories?.length;

				if (!showAccordion) {
					return (
						<SingleLink
							pageDepth={pageDepth}
							callback={trackMenu}
							page={page}
							key={page.text}
							hideIcons={hideIcons}
							label={label}
						/>
					);
				}

				return (
					<LinkWithPage
						pageClick={pageClick}
						callback={trackMenu}
						hideIcons={hideIcons}
						page={page}
						key={page.text}
						label={label}
					/>
				);
			})}
		</div>
	);
}

export default DrawerMenuLinks;
